export default "__VITE_ASSET__JKZVigFb__"